import { IconPropsType } from "./type";

export const Components = ({
  size = 24,
  color = "currentColor",
}: IconPropsType) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M10.3574 7.52864C10.2324 7.65366 10.1622 7.82319 10.1622 7.99997C10.1622 8.17675 10.2324 8.34628 10.3574 8.4713L11.9414 10.056C12.0664 10.181 12.2359 10.2512 12.4127 10.2512C12.5895 10.2512 12.759 10.181 12.884 10.056L14.4687 8.4713C14.5937 8.34628 14.6639 8.17675 14.6639 7.99997C14.6639 7.82319 14.5937 7.65366 14.4687 7.52864L12.884 5.94397C12.759 5.81899 12.5895 5.74878 12.4127 5.74878C12.2359 5.74878 12.0664 5.81899 11.9414 5.94397L10.3574 7.52864Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.53131 7.52864C1.40633 7.65366 1.33612 7.82319 1.33612 7.99997C1.33612 8.17675 1.40633 8.34628 1.53131 8.4713L3.11598 10.056C3.241 10.181 3.41054 10.2512 3.58731 10.2512C3.76409 10.2512 3.93363 10.181 4.05864 10.056L5.64331 8.4713C5.76829 8.34628 5.8385 8.17675 5.8385 7.99997C5.8385 7.82319 5.76829 7.65366 5.64331 7.52864L4.05864 5.94397C3.93363 5.81899 3.76409 5.74878 3.58731 5.74878C3.41054 5.74878 3.241 5.81899 3.11598 5.94397L1.53131 7.52864Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.944 11.9413C5.88201 12.0032 5.83284 12.0767 5.79929 12.1577C5.76574 12.2386 5.74847 12.3254 5.74847 12.413C5.74847 12.5006 5.76574 12.5873 5.79929 12.6683C5.83284 12.7492 5.88201 12.8227 5.944 12.8846L7.52867 14.4686C7.65368 14.5936 7.82322 14.6638 8 14.6638C8.17677 14.6638 8.34631 14.5936 8.47133 14.4686L10.056 12.8846C10.118 12.8227 10.1672 12.7492 10.2007 12.6683C10.2343 12.5873 10.2515 12.5006 10.2515 12.413C10.2515 12.3254 10.2343 12.2386 10.2007 12.1577C10.1672 12.0767 10.118 12.0032 10.056 11.9413L8.47133 10.3573C8.34631 10.2323 8.17677 10.1621 8 10.1621C7.82322 10.1621 7.65368 10.2323 7.52867 10.3573L5.944 11.9413Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.94397 3.11604C5.81899 3.24106 5.74878 3.4106 5.74878 3.58737C5.74878 3.76415 5.81899 3.93369 5.94397 4.05871L7.52864 5.64271C7.65366 5.76769 7.82319 5.8379 7.99997 5.8379C8.17675 5.8379 8.34628 5.76769 8.4713 5.64271L10.056 4.05871C10.181 3.93369 10.2512 3.76415 10.2512 3.58737C10.2512 3.4106 10.181 3.24106 10.056 3.11604L8.4713 1.53137C8.34628 1.40639 8.17675 1.33618 7.99997 1.33618C7.82319 1.33618 7.65366 1.40639 7.52864 1.53137L5.94397 3.11604Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
